import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../../header/Header';
import Footer from '../../footer/Footer';
import imageCompression from 'browser-image-compression';
import FilePreviewModal from './FilePreview';
import InvalidQrCode from '../../invalidPages/invalidQrCode';
import SubmitFail from '../../invalidPages/SubmitFail';
import AlreadyRegistered from '../../invalidPages/AlreadyRegistered';
import ServerError from '../../invalidPages/ServerError';
import { getHeaders } from '../../apiHeader/ApiHeader';
import SuccessRegistration from '../../invalidPages/SuccessRegistration';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { ClipLoader } from 'react-spinners';
import axios from 'axios';
import './ProductRegistrationForm.css';

// Add custom styles for IntlTelInput flag positioning
const customStyles = `
  .intl-tel-input {
    width: 100% !important;
    position: relative !important;
  }
  
  .intl-tel-input .selected-flag {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    z-index: 2 !important;
    background: white !important;
    border: 2px solid #e5e7eb !important;
    border-right: 1px solid #e5e7eb !important;
    border-radius: 0.75rem 0 0 0.75rem !important;
    padding: 0 6px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 60px !important;
    height: 56px !important;
    cursor: pointer !important;
    gap: 4px !important;
  }
  
  .intl-tel-input .selected-flag:hover {
    background: #f9fafb !important;
    border-color: #d1d5db !important;
  }
  
  .intl-tel-input .selected-flag .flag {
    width: 20px !important;
    height: 15px !important;
    background-size: contain !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    margin: 0 !important;
    flex-shrink: 0 !important;
    display: block !important;
    align-self: center !important;
  }
  
  /* Hide all default arrows and create only one custom arrow */
  .intl-tel-input .selected-flag .arrow,
  .intl-tel-input .selected-flag .iti-arrow {
    display: none !important;
  }
  
  /* Create a single custom arrow using ::after pseudo-element */
  .intl-tel-input .selected-flag::after {
    content: '' !important;
    width: 0 !important;
    height: 0 !important;
    border-left: 3px solid transparent !important;
    border-right: 3px solid transparent !important;
    border-top: 4px solid #6b7280 !important;
    margin: 0 !important;
    display: block !important;
    flex-shrink: 0 !important;
    align-self: center !important;
  }
  
  .intl-tel-input input.form-control {
    width: 100% !important;
    height: 56px !important;
    padding: 16px 16px 16px 72px !important;
    border: 2px solid #e5e7eb !important;
    border-radius: 0.75rem !important;
    font-size: 16px !important;
    line-height: 1.5 !important;
    background: white !important;
    transition: all 0.3s ease !important;
    box-sizing: border-box !important;
  }
  
  .intl-tel-input input.form-control:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1) !important;
    outline: none !important;
    background: white !important;
  }
  
  .intl-tel-input input.form-control:hover {
    border-color: #d1d5db !important;
  }
  
  .intl-tel-input .country-list {
    position: absolute !important;
    z-index: 1000 !important;
    background: white !important;
    border: 2px solid #e5e7eb !important;
    border-radius: 0.75rem !important;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    width: 300px !important;
    margin-top: 4px !important;
  }
  
  .intl-tel-input .country {
    padding: 10px 12px !important;
    cursor: pointer !important;
    border-bottom: 1px solid #f3f4f6 !important;
    display: flex !important;
    align-items: center !important;
  }
  
  .intl-tel-input .country:hover {
    background: #f9fafb !important;
  }
  
  .intl-tel-input .country.highlight {
    background: #eff6ff !important;
  }
  
  .intl-tel-input .country .flag {
    margin-right: 10px !important;
    width: 20px !important;
    height: 15px !important;
  }
  
  .intl-tel-input .country .country-name {
    flex: 1 !important;
    font-size: 14px !important;
  }
  
  .intl-tel-input .country .dial-code {
    font-size: 14px !important;
    color: #6b7280 !important;
  }
`;

// Inject custom styles
if (typeof document !== 'undefined') {
  const existingStyle = document.getElementById('intl-tel-input-custom-styles');
  if (!existingStyle) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'intl-tel-input-custom-styles';
    styleSheet.innerText = customStyles;
    document.head.appendChild(styleSheet);
  }
}

function ProductRegistrationForm() {
    const { productId } = useParams();
    const [productName, setProductName] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [companyLogo, setCompanyLogo] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [dateOfPurchase, setDateOfPurchase] = useState('');
    const [file, setFile] = useState(null);
    const [fileUrl, setFileUrl] = useState('');
    const [errors, setErrors] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [mobile, setMobile] = useState('');
    const [countryCode, setCountryCode] = useState("+91");
    const [submitFail, setSubmitFail] = useState(false);
    const [invalidQrCode, setInvalidQrCode] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    const [isRegistered, setIsRegistered] = useState(false);
    const [serverError, setServerError] = useState(false);
    const [isSuccessRegistered, setIsSuccessRegistered] = useState(false);
    const [maxLength, setMaxLength] = useState('15');
    const [isValidMobile, SetIsValidMobile] = useState('');
    const fileInputRef = useRef(null);
    const [isChecked, setIsChecked] = useState(false);
    const [brandName, setBrandName] = useState('');
    const [companyWebsite, setCompanyWebsite] = useState('');
    const [companyInfo, setCompanyInfo] = useState(null); // Added company info state
    
    // New states for user signup flow
    const [currentStep, setCurrentStep] = useState('form'); // 'form', 'otp', 'register'
    const [userSignupData, setUserSignupData] = useState(null);
    const [otpCode, setOtpCode] = useState('');
    const [isOtpLoading, setIsOtpLoading] = useState(false);
    const [otpErrors, setOtpErrors] = useState({});
    const [showResendOtp, setShowResendOtp] = useState(false);
    const [resendTimer, setResendTimer] = useState(0);
    
    const { t } = useTranslation();
    const API_URL = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        fetchProductInfo();
    }, []);

    useEffect(() => {
        if (isSuccessRegistered || submitFail || invalidQrCode || serverError || isRegistered) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [isSuccessRegistered, submitFail, invalidQrCode, serverError, isRegistered]);

    // Reset states when step changes
    useEffect(() => {
        if (currentStep === 'form') {
            setOtpCode('');
            setOtpErrors({});
            setShowResendOtp(false);
            setResendTimer(0);
        }
    }, [currentStep]);

    const handleKeyPress = (e) => {
        const regex = /^[A-Za-z]*$/;
        if (!regex.test(e.key)) {
            e.preventDefault();
        }
    };

    const resetUserAttributes = () => {
        setFirstName('');
        setLastName('');
        setMobile('');
        setEmail('');
        setDateOfPurchase('');
        setFile(null);
        setFileUrl('');
        setCurrentStep('form');
        setUserSignupData(null);
        setOtpCode('');
        setOtpErrors({});
        setShowResendOtp(false);
        setResendTimer(0);
    }

    const handleMobileNumberChange = (isValid, value, countryData) => {
        const newErrors = {};
        const numericValue = value.replace(/\D/g, '').slice(0, 15);
        const dialCode = countryData.dialCode || '';

        if (isValid) {
            SetIsValidMobile(true);
            setErrors({});
        } else {
            SetIsValidMobile(false);
            newErrors.mobile = t('mobileValid');
            setErrors(newErrors);
        }
        setMobile(numericValue);
        setCountryCode(dialCode);
        setMaxLength(maxLength);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Backspace') {
            setMobile(event.target.value);
        }
    };

    const fetchProductInfo = async () => {
        setInvalidQrCode(false);
        try {
            const headers = await getHeaders();
            const response = await fetch(`${API_URL}/registrationv2/verify`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ operation: "verify",code: productId })
            });
            const data = await response.json();
            if (response.ok) {
                if (data.status === "UNREGISTERED") {
                    setCompanyLogo(data.productSpec.companyInfo.logoURL);
                    setBrandName(data.productSpec.companyInfo.name);
                    setSerialNumber(data.productSpec.productInfo.serialNo);
                    setProductName(data.productSpec.productInfo.modelName);
                    setCompanyWebsite(data.productSpec.companyInfo.website);
                    setCompanyInfo(data.productSpec.companyInfo); // Store company info
                    setInvalidQrCode(false);
                } else if (data.status === "REGISTERED") {
                    setCompanyLogo(data.productSpec.companyInfo.logoURL);
                    setBrandName(data.productSpec.companyInfo.name);
                    setSerialNumber(data.productSpec.productInfo.serialNo);
                    setProductName(data.productSpec.productInfo.modelName);
                    setIsRegistered(true);
                    setCompanyWebsite(data.productSpec.companyInfo.website);
                    setCompanyInfo(data.productSpec.companyInfo); // Store company info
                    setEmail(data.userInfo.email);
                    setMobile(data.userInfo.mobileNumber);
                } else {
                    setInvalidQrCode(true);
                }
            } else {
                if (response.status === 400) {
                    setInvalidQrCode(true);
                } else {
                    setServerError(true);
                }
            }
        } catch (error) {
            setServerError(true);
        } finally {
            setIsFetching(false);
        }
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file && file.size <= 10 * 1024 * 1024) { // Ensure file size is within 10 MB
            try {
                if (file.type === 'application/pdf') {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setFileUrl(reader.result); // Set the file URL for preview
                    };
                    reader.readAsDataURL(file);
                    setFile(file);
                    setErrors((prevErrors) => ({ ...prevErrors, file: '' })); // Clear file-related errors
                }
                else if (file.type.startsWith('image/')) {
                    // Handle image files (JPG, PNG, etc.)
                    const options = {
                        maxSizeMB: 1,
                        maxWidthOrHeight: 1920,
                        useWebWorker: true
                    };
                    const compressedFile = await imageCompression(file, options);
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setFileUrl(reader.result); // Set the file URL for preview
                    };
                    reader.readAsDataURL(compressedFile);
                    setFile(compressedFile);
                    setErrors((prevErrors) => ({ ...prevErrors, file: '' })); // Clear file-related errors
                } else {
                    // Invalid file type
                    setFile(null);
                    setFileUrl('');
                    setErrors((prevErrors) => ({ ...prevErrors, file: t('invalidFileType') })); // Show error for invalid file type
                }
            } catch (error) {
                setErrors((prevErrors) => ({ ...prevErrors, file: t('errorProcessingFile') })); // Show error for processing issues
            }
        } else {
            // File size exceeds limit
            setFile(null);
            setFileUrl('');
            setErrors((prevErrors) => ({ ...prevErrors, file: t('fileSizeError') })); // Show error for file size
        }
    };

    // User Signup API call
    const handleUserSignup = async (userData) => {
        setIsLoading(true);
        setErrors({});
        
        try {
            const headers = await getHeaders();
            const response = await fetch(`${API_URL}/registration/user`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    operation: "signup",
                    userInfo: {
                        firstName: userData.firstName,
                        lastName: userData.lastName,
                        mobileCountryCode: userData.countryCode,
                        mobileNumber: userData.mobile,
                        email: userData.email
                    }
                })
            });

            const data = await response.json();
            
            if (data.success) {
                if (data.result.status === "CONFIRMED" || data.result.status === "EXTERNAL_PROVIDER") {
                    // User already confirmed or using external provider, automatically proceed with product registration
                    setIsLoading(false); // Stop loading from signup
                    await handleProductRegistration();
                } else if (data.result.status === "UNCONFIRMED") {
                    // Show OTP screen
                    setCurrentStep('otp');
                    setUserSignupData(userData);
                    startResendTimer();
                }
            } else {
                // Handle signup errors
                setErrors({ general: data.message || 'Signup failed. Please try again.' });
            }
        } catch (error) {
            setErrors({ general: 'Network error. Please try again.' });
        } finally {
            setIsLoading(false);
        }
    };

    // OTP Verification API call
    const handleOtpVerification = async () => {
        if (!otpCode || otpCode.length !== 6) {
            setOtpErrors({ otp: 'Please enter a valid 6-digit OTP code.' });
            return;
        }

        setIsOtpLoading(true);
        setOtpErrors({});

        try {
            const headers = await getHeaders();
            const response = await fetch(`${API_URL}/registration/user`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    operation: "verify",
                    attributeType: "EMAIL",
                    attributeValue: email,
                    code: otpCode
                })
            });

            const data = await response.json();
            
            if (data.success) {
                setOtpCode('');
                // Keep loading state active and proceed to product registration
                await handleProductRegistration();
            } else {
                setOtpErrors({ otp: 'Invalid OTP code. Please try again.' });
                setIsOtpLoading(false);
            }
        } catch (error) {
            setOtpErrors({ otp: 'Network error. Please try again.' });
            setIsOtpLoading(false);
        }
    };

    // Resend OTP API call
    const handleResendOtp = async () => {
        setIsOtpLoading(true);
        setOtpErrors({});

        try {
            const headers = await getHeaders();
            const response = await fetch(`${API_URL}/registration/user`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    operation: "resend",
                    attributeType: "EMAIL",
                    attributeValue: email
                })
            });

            const data = await response.json();
            
            if (data.success) {
                setShowResendOtp(false);
                startResendTimer();
                // Show success message or toast
            } else {
                setOtpErrors({ general: 'Failed to resend OTP. Please try again.' });
            }
        } catch (error) {
            setOtpErrors({ general: 'Network error. Please try again.' });
        } finally {
            setIsOtpLoading(false);
        }
    };

    // Timer for resend OTP
    const startResendTimer = () => {
        setResendTimer(60); // 60 seconds
        const timer = setInterval(() => {
            setResendTimer((prev) => {
                if (prev <= 1) {
                    setShowResendOtp(true);
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const validateForm = () => {
        const newErrors = {};
        if (!firstName) newErrors.firstName = t('firstNameRequired');
        if (!lastName) newErrors.lastName = t('lastNameRequired');
        if (!mobile) {
            newErrors.mobile = t('mobileRequired');
        } else if (isValidMobile === false) {
            newErrors.mobile = t('mobileValid');
        }
        if (!email) {
            newErrors.email = t('emailRequired');
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = t('emailInvalid');
        }
        if (!dateOfPurchase) newErrors.dateOfPurchase = t('dateOfPurchaseRequired');
        if (!file) newErrors.file = t('fileRequired');
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Check if all required form fields are filled for button styling
    const isFormComplete = () => {
        return firstName.trim() !== '' && 
               lastName.trim() !== '' && 
               email.trim() !== '' && 
               mobile.trim() !== '' && 
               dateOfPurchase !== '' && 
               file !== null && 
               isChecked;
    };



const convertFileToUrl = async (file) => {
    if (file && file.size <= 10 * 1024 * 1024) { // Ensure file size is within 10 MB
        try {
        let fileToUpload = file;
        // Compress image files only
        if (file.type.startsWith('image/')) {
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            };
            fileToUpload = await imageCompression(file, options);
        }
                // Step 1: Get the pre-signed URL
                const response = await axios.post(`${API_URL}/media/web-upload`, 
                    [{
                        fileName: file.name,
                        contentType: file.type,
                        channel: 'QRCodeRegistrations'
                    }],
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });
                const { uploadURL, Key } = response.data[0];

                // Step 2: Upload the file content to the pre-signed URL
                await axios.put(uploadURL, fileToUpload, {
                    headers: {
                        'Content-Type': file.type,
                    }
                });
                // return key which will be saved in dynamodb
                return Key;
        } catch (error) {
            console.error('Error during file upload:', error);
            throw new Error(t('errorProcessingFile'));
        }
    } else {
        throw new Error(t('fileSizeError'));
    }
};

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsValidating(true);
        setSubmitFail(false);
        
        if (validateForm()) {
            // First step: User signup
            const userData = {
                firstName,
                lastName,
                mobile,
                countryCode: "+" + countryCode,
                email
            };
            
            await handleUserSignup(userData);
        }
        setIsValidating(false);
    };

    // Separate function for product registration after user verification
    const handleProductRegistration = async () => {
        setIsLoading(true);
        setSubmitFail(false);

            const purchaseTimeInMs = new Date(dateOfPurchase).getTime();
            const purchaseTimeSecs = Math.floor(purchaseTimeInMs / 1000);

        try {
            const fileUrl = await convertFileToUrl(file);
            const formData = {
                operation: "add",
                code: productId,
                userInfo: {
                    firstName,
                    lastName,
                    mobileCountryCode: "+" + countryCode,
                    mobileNumber: mobile,
                    email
                },
                popImages: [
                    {
                        name: file.name,
                        url: fileUrl
                    }
                ],
                dateOfPurchase: purchaseTimeSecs
            };

            const headers = await getHeaders();
            const response = await fetch(`${API_URL}/registrationv2/register`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(formData)
            });

            const data = await response.json();
            resetUserAttributes();
            if (response.status === 200) {
                setIsSuccessRegistered(true);
                setErrors({});
                setCurrentStep('form'); // Reset to initial step
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            } else if (response.status === 400) {
                setInvalidQrCode(true);
            } else if (response.status === 500) {
                setServerError(true);
            } else {
                setSubmitFail(true);
            }
        } catch (error) {
            setSubmitFail(true);
        } finally {
            setIsLoading(false);
            setIsOtpLoading(false); // Also stop OTP loading state
        }
    };

    const handleMobileKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleMobilePaste = (e) => {
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        if (!/^\d+$/.test(paste)) {
            e.preventDefault();
        }
    };

    return (
        <div className='min-h-screen flex flex-col bg-gradient-to-br from-[#0a3891] via-[#0a3891] to-[#0a3891] relative overflow-hidden'>
            {/* Animated background elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-white/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
                <div className="absolute top-1/2 left-1/2 w-60 h-60 bg-white/5 rounded-full blur-3xl animate-pulse" style={{animationDelay: '4s'}}></div>
            </div>
            <Header />
            <div className='flex-grow flex items-center justify-center p-0 md:px-20 md:py-10 relative z-10'>
                <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                {(isValidating || (isOtpLoading && currentStep === 'otp')) && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 animate-fadeIn">
                        <div className="bg-white text-gray-800 p-8 rounded-2xl shadow-2xl text-center transform animate-slideUp max-w-sm mx-4">
                            <div className="relative">
                                <div className="absolute inset-0 bg-gradient-to-r from-[#F7941D] to-[#ff6b35] rounded-full animate-pulse opacity-20"></div>
                                <ClipLoader size={50} color={"#F7941D"} />
                            </div>
                            <h2 className="text-xl font-bold mt-6 bg-gradient-to-r from-[#0a3891] to-[#0a3891] bg-clip-text text-transparent">
                                {isValidating && t('processing')}
                                {isOtpLoading && currentStep === 'otp' && 'Verifying code and registering product...'}
                            </h2>
                            <p className="text-sm text-gray-600 mt-3 animate-pulse">Please wait while we process your request</p>
                            <div className="flex justify-center mt-4 space-x-1">
                                <div className="w-2 h-2 bg-[#F7941D] rounded-full animate-bounce"></div>
                                <div className="w-2 h-2 bg-[#F7941D] rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                                <div className="w-2 h-2 bg-[#F7941D] rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
                            </div>
                        </div>
                    </div>
                )}
                {isFetching ? (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        {/* Add a loading spinner */}
        <div className="text-center">
            <svg
                className="animate-spin h-10 w-10 text-[#0a3891] mx-auto"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                ></circle>
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                ></path>
            </svg>
            <h2 className="text-lg font-bold text-[#0a3891] mt-4">
                {t('fetching_details')}
            </h2>
        </div>
    </div>) : (
                    isSuccessRegistered ? <SuccessRegistration /> : invalidQrCode ? <InvalidQrCode /> : serverError ? <ServerError /> :
                    <div className='bg-white/95 backdrop-blur-xl text-[#424553] text-center p-6 md:p-12 
                    rounded-b-none md:rounded-3xl 
                    rounded-t-3xl 
                    max-w-7xl w-full mx-auto transform animate-slideUp
                    border border-white/20 shadow-2xl' 
                    style={{ 
                      fontFamily: 'Assistant, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', 
                      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1)', 
                      backgroundImage: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%)',
                      backgroundSize: 'cover', 
                      backgroundPosition: 'center' 
                    }}
                  >
                            
                            {/* Add Product details heading here */}
                            {/* <h2 className="text-xl font-bold text-left mb-4">Product details</h2> */}
                            <div className='grid grid-cols-1 md:grid-cols-3 gap-4 text-left'>
                                  {/* Brand Logo Section */}
    <div className='col-span-3 text-center mb-6'>
        {companyLogo ? (
        <a href={companyWebsite} target="_blank" rel="noopener noreferrer">
            <img 
                src={companyLogo} 
                alt="Company Logo" 
                className="h-auto w-auto mx-auto" // Increased size and centered the logo
            />
        </a>
        ) : null}
    </div>
    
    {/* Eye-catching 20% Discount Message */}
    <div className='col-span-3 mb-8'>
        <div className="relative overflow-hidden bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 rounded-3xl p-6 shadow-2xl transform hover:scale-105 transition-all duration-300">
            {/* Animated background elements */}
            <div className="absolute inset-0 bg-white/10 rounded-3xl"></div>
            <div className="absolute -top-20 -right-20 w-40 h-40 bg-white/10 rounded-full animate-pulse"></div>
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
            
                <div className="relative z-10 text-center">
                    <div className="mb-3">
                        <h3 className="text-2xl md:text-3xl font-black text-white mb-1">🎉 {t('form_special_offer_title')} 🎉</h3>
                        <p className="text-white/90 text-sm md:text-base font-medium">{t('form_special_offer_subtitle')}</p>
                    </div>

                    {/* <div className="max-w-2xl mx-auto bg-white/10 backdrop-blur-sm rounded-2xl p-4 my-4">
                        <p className="text-white/90 text-lg md:text-xl font-medium">{t('form_special_offer_note')}</p>
                    </div> */}

                    {/* <div className="text-center mb-4">
                        <p className="text-white text-sm md:text-base font-semibold mb-1">✨ {t('form_register_warranty')} ✨</p>
                        <p className="text-white/80 text-xs md:text-sm">{t('form_discount_code')}</p>
                    </div> */}

                    {/* Gizmore Contact Links - compact pill style */}
                    {/* <div className="mt-4 text-center">
                        <h4 className="text-white font-semibold mb-2">{t('gizmore_contact_title')}</h4>
                        <div className="flex flex-wrap items-center justify-center gap-3">
                            <a href={`mailto:${t('gizmore_email')}`} className="contact-pill">
                                <span className="mr-2">📧</span>{t('gizmore_email')}
                            </a>
                            <a href={`tel:${(t('gizmore_phone')||'').replace(/[^0-9+]/g,'')}`} className="contact-pill">
                                <span className="mr-2">📞</span>{t('gizmore_phone')}
                            </a>
                            <a href={t('gizmore_social_facebook')} target="_blank" rel="noopener noreferrer" className="contact-pill">
                                <span className="mr-2">🔵</span>Facebook
                            </a>
                            <a href={t('gizmore_social_instagram')} target="_blank" rel="noopener noreferrer" className="contact-pill">
                                <span className="mr-2">📸</span>Instagram
                            </a>
                            <a href={t('gizmore_social_x')} target="_blank" rel="noopener noreferrer" className="contact-pill">
                                <span className="mr-2">✖️</span>X
                            </a>
                        </div>
                    </div> */}

                    {/* Sparkle animations */}
                    <div className="absolute top-4 left-4 text-white/60 animate-ping">⭐</div>
                    <div className="absolute top-6 right-8 text-white/60 animate-ping" style={{animationDelay: '0.5s'}}>✨</div>
                    <div className="absolute bottom-4 left-8 text-white/60 animate-ping" style={{animationDelay: '1s'}}>💫</div>
                    <div className="absolute bottom-6 right-4 text-white/60 animate-ping" style={{animationDelay: '1.5s'}}>⚡</div>
                </div>
        </div>
    </div>
  </div>
<div className='grid grid-cols-1 md:grid-cols-3 gap-4 text-left'>
  <div className='col-span-1 mb-2'>
    <p className='mb-1 text-gray-600'>{t('form_company')}</p>
    <div className='flex items-center border rounded p-2 bg-gray-50'>
      <span>{brandName || t('form_brand')}</span>
    </div>
  </div>
  
  <div className='col-span-1 mb-2'>
    <p className='mb-1 text-gray-600'>{t('form_product')}</p>
    <div className='flex items-center border rounded p-2 bg-gray-50'>
      {productName || t('form_product_model')}
    </div>
  </div>
  
  <div className='col-span-1 mb-2'>
    <p className='mb-1 text-gray-600'>{t('form_serial_number')}</p>
    <div className='flex items-center border rounded p-2 bg-gray-50'>
      {serialNumber || t('form_serial_number')}
    </div>
  </div>
</div>


                            {submitFail ? <SubmitFail /> : isRegistered ? <AlreadyRegistered email={email} mobile={mobile} /> :
                                
                                <>
                                    {/* Enhanced Step indicators */}
                                    <div className="mb-8">
                                        <div className="flex items-center justify-center mb-6">
                                            <div className={`flex items-center transition-all duration-500 ${currentStep === 'form' ? 'text-blue-600 scale-105' : currentStep === 'otp' || currentStep === 'register' ? 'text-green-600' : 'text-gray-400'}`}>
                                                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg transition-all duration-500 transform hover:scale-110 shadow-lg ${currentStep === 'form' ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-blue-200' : currentStep === 'otp' || currentStep === 'register' ? 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-green-200' : 'bg-gray-200 text-gray-600'}`}>
                                                    {currentStep === 'otp' || currentStep === 'register' ? (
                                                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                        </svg>
                                                    ) : '1'}
                                                </div>
                                                <span className="ml-3 hidden sm:inline font-semibold">User Details</span>
                                            </div>
                                            <div className="flex-1 h-1 bg-gray-200 mx-6 rounded-full overflow-hidden">
                                                <div className={`h-full transition-all duration-700 ease-out rounded-full ${currentStep === 'otp' || currentStep === 'register' ? 'bg-gradient-to-r from-green-400 to-green-600 w-full' : 'bg-gray-200 w-0'}`}></div>
                                            </div>
                                            <div className={`flex items-center transition-all duration-500 ${currentStep === 'otp' ? 'text-blue-600 scale-105' : currentStep === 'register' ? 'text-green-600' : 'text-gray-400'}`}>
                                                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg transition-all duration-500 transform hover:scale-110 shadow-lg ${currentStep === 'otp' ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-blue-200' : currentStep === 'register' ? 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-green-200' : 'bg-gray-200 text-gray-600'}`}>
                                                    {currentStep === 'register' ? (
                                                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                        </svg>
                                                    ) : '2'}
                                                </div>
                                                <span className="ml-3 hidden sm:inline font-semibold">Verification</span>
                                            </div>
                                            <div className="flex-1 h-1 bg-gray-200 mx-6 rounded-full overflow-hidden">
                                                <div className={`h-full transition-all duration-700 ease-out rounded-full ${currentStep === 'register' ? 'bg-gradient-to-r from-green-400 to-green-600 w-full' : 'bg-gray-200 w-0'}`}></div>
                                            </div>
                                            <div className={`flex items-center transition-all duration-500 ${currentStep === 'register' ? 'text-blue-600 scale-105' : 'text-gray-400'}`}>
                                                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg transition-all duration-500 transform hover:scale-110 shadow-lg ${currentStep === 'register' ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-blue-200' : 'bg-gray-200 text-gray-600'}`}>
                                                    3
                                                </div>
                                                <span className="ml-3 hidden sm:inline font-semibold">Registration</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* User Details Form */}
                                    {currentStep === 'form' && (
                                        <form onSubmit={handleSubmit} className='text-left animate-fadeIn'>
                                    <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
                                        <div className='col-span-1 mb-4 group'>
                                            <label className='block mb-2 font-bold text-gray-700 transition-colors group-focus-within:text-blue-600'>{t('first_name')}<span className="text-red-500 ml-1">*</span></label>
                                            <div className="relative">
                                                <input 
                                                    type="text" 
                                                    value={firstName}  
                                                    placeholder={t('form_first_name_placeholder')} 
                                                    onChange={(e) => setFirstName(e.target.value)} 
                                                    maxLength={20} 
                                                    className='w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 hover:border-gray-300 bg-white focus:bg-white shadow-sm' 
                                                    onKeyPress={handleKeyPress} 
                                                />
                                            </div>
                                            {errors.firstName && <p className="text-red-500 text-sm mt-2 animate-slideDown flex items-center"><svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>{errors.firstName}</p>}
                                        </div>
                                        <div className='col-span-1 mb-4 group'>
                                            <label className='block mb-2 font-bold text-gray-700 transition-colors group-focus-within:text-blue-600'>{t('last_name')}<span className="text-red-500 ml-1">*</span></label>
                                            <div className="relative">
                                                <input 
                                                    type="text" 
                                                    value={lastName} 
                                                    onChange={(e) => setLastName(e.target.value)} 
                                                    maxLength={20} 
                                                    className='w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 hover:border-gray-300 bg-white focus:bg-white shadow-sm' 
                                                    onKeyPress={handleKeyPress} 
                                                    placeholder={t('form_last_name_placeholder')} 
                                                />
                                            </div>
                                            {errors.lastName && <p className="text-red-500 text-sm mt-2 animate-slideDown flex items-center"><svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>{errors.lastName}</p>}
                                        </div>
                                        <div className='col-span-1 mb-4 group'>
                                            <label className='block mb-2 font-bold text-gray-700 transition-colors group-focus-within:text-blue-600'>{t('mobile')}<span className="text-red-500 ml-1">*</span></label>
                                            <div className="relative">
                                                <IntlTelInput
                                                    preferredCountries={['in', 'au', 'us', 'gb', 'jp']}
                                                    defaultCountry="in"
                                                    value={mobile}
                                                    onPhoneNumberChange={handleMobileNumberChange}
                                                    containerClassName="intl-tel-input w-full"
                                                    inputClassName="form-control"
                                                    autoPlaceholder={true}
                                                    onKeyDown={handleKeyDown}
                                                    formatOnDisplay={true}
                                                    separateDialCode={false}
                                                />
                                            </div>
                                            {errors.mobile && <p className="text-red-500 text-sm mt-2 animate-slideDown flex items-center"><svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>{errors.mobile}</p>}
                                        </div>
                                        <div className='col-span-1 mb-4 group'>
                                            <label className='block mb-2 font-bold text-gray-700 transition-colors group-focus-within:text-blue-600'>{t('email')}<span className="text-red-500 ml-1">*</span></label>
                                            <div className="relative">
                                                <input 
                                                    type="email" 
                                                    value={email} 
                                                    onChange={(e) => setEmail(e.target.value)} 
                                                    className='w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 hover:border-gray-300 bg-white focus:bg-white shadow-sm' 
                                                    placeholder={t('form_email_placeholder')} 
                                                />
                                            </div>
                                            {errors.email && <p className="text-red-500 text-sm mt-2 animate-slideDown flex items-center"><svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>{errors.email}</p>}
                                        </div>
                                        <div className='col-span-1 mb-4 group'>
        <label className='block mb-2 font-bold text-gray-700 transition-colors group-focus-within:text-blue-600'>{t('date_of_purchase')}<span className="text-red-500 ml-1">*</span></label>
        <div className="relative">
            <input 
                type="date" 
                value={dateOfPurchase} 
                onChange={(e) => setDateOfPurchase(e.target.value)} 
                max={getTodayDate()} 
                className='w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 hover:border-gray-300 bg-white focus:bg-white shadow-sm' 
                placeholder={t('form_purchase_date_placeholder')}
            />
        </div>
        {errors.dateOfPurchase && <p className="text-red-500 text-sm mt-2 animate-slideDown flex items-center"><svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>{errors.dateOfPurchase}</p>}
    </div>

    <div className='col-span-1 mb-4 group'>
    <label className='block mb-2 font-bold text-gray-700 transition-colors group-focus-within:text-blue-600'>{t('attach_bill')}<span className="text-red-500 ml-1">*</span></label>
    <div className="relative">
        <div className={`border-2 border-dashed rounded-xl p-6 transition-all duration-300 cursor-pointer hover:border-blue-400 hover:bg-blue-50 ${file ? 'border-green-400 bg-green-50' : 'border-gray-300 bg-gray-50'}`} onClick={() => fileInputRef.current.click()}>
            <div className="text-center">
                <div className="mx-auto mb-4">
                    {file ? (
                        <svg className="w-12 h-12 text-green-500 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
                        </svg>
                    ) : (
                        <svg className="w-12 h-12 text-gray-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 48 48">
                            <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                </div>
                <div className="space-y-2">
                    {file ? (
                        <div>
                            <p className="text-green-700 font-semibold">{file.name}</p>
                            <p className="text-green-600 text-sm">{t('form_file_upload_success')}</p>
                        </div>
                    ) : (
                        <div>
                            <p className="text-gray-600 font-semibold">{t('form_drop_file')}</p>
                            <p className="text-gray-500 text-sm">{t('form_upload_bill')}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
        <input 
            type="file" 
            accept="image/*,.pdf" 
            onChange={handleFileChange} 
            ref={fileInputRef} 
            className='hidden' 
        />
    </div>
    {fileUrl && (
        <div className='mt-3 text-center'>
            <button 
                type="button"
                onClick={() => setIsModalOpen(true)} 
                className='inline-flex items-center px-4 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors duration-200 font-medium'
            >
                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                    <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                </svg>
                {t('file_preview')}
            </button>
        </div>
    )}
    {errors.file && <p className="text-red-500 text-sm mt-2 animate-slideDown flex items-center"><svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>{errors.file}</p>}
</div>

                                    </div>
                                    
                                    <div className="border border-amber-200 bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-6 my-6 shadow-lg hover:shadow-xl transition-all duration-300 transform">
                                        <div className="flex items-center mb-4">
                                            <div className="w-10 h-10 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full flex items-center justify-center mr-3 shadow-lg">
                                                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <h3 className="font-bold text-lg text-gray-800">🎉 {t('form_warranty_benefits')}</h3>
                                        </div>
                                        <div className="space-y-3">
                                            <div className="flex items-start">
                                                <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                                <p className="text-gray-700 font-medium">{t('form_priority_support')}</p>
                                            </div>
                                            <div className="flex items-start">
                                                <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                                <p className="text-gray-700 font-medium">{t('form_extended_warranty')}</p>
                                            </div>
                                            <div className="flex items-start">
                                                <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                                <p className="text-gray-700 font-medium">{t('form_track_warranty')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="mb-8">
    <label className="flex items-start cursor-pointer group">
        <input 
            type="checkbox" 
            className="sr-only" 
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
        />
        <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all duration-200 flex-shrink-0 ${isChecked ? 'bg-blue-600 border-blue-600' : 'border-gray-300 group-hover:border-blue-400'}`}>
            {isChecked && (
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
            )}
        </div>
        <span className="ml-3 text-gray-700 leading-relaxed">{t('form_terms_agreement')} <Link to="" className="text-blue-600 hover:text-blue-800 font-semibold underline decoration-2 decoration-blue-200 hover:decoration-blue-400 transition-colors">{t('form_terms_service')}</Link> {t('form_and')} <Link to="/privacy-policy" className="text-blue-600 hover:text-blue-800 font-semibold underline decoration-2 decoration-blue-200 hover:decoration-blue-400 transition-colors">{t('form_privacy_policy')}</Link></span>
    </label>
</div>
                                    {/* Moved the button outside the grid, as shown in the image */}
                                    
                                       {/* Moved the button outside the grid, as shown in the image */}
                                       <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
    <div className='col-span-1 md:col-start-2'>
        <button
            type="submit"
            disabled={isLoading || !isChecked || !isFormComplete()}
            className={`w-full text-white py-4 text-lg font-bold rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-orange-300 ${
                isLoading || !isChecked || !isFormComplete()
                    ? 'bg-gray-400 cursor-not-allowed opacity-60' 
                    : 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 shadow-lg hover:shadow-green-300/50'
            }`}
        >
            {isLoading ? (
                <div className="flex items-center justify-center">
                    <ClipLoader size={24} color={"#fff"} />
                    <span className="ml-3">{t('form_processing')}</span>
                </div>
            ) : (
                <div className="flex items-center justify-center">
                    <span>{t('form_continue')}</span>
                    <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </div>
            )}
        </button>
    </div>
</div>
                                            {errors.general && <p className="text-red-500 text-center mt-4">{errors.general}</p>}                            
                                        </form>
                                    )}

                                    {/* Enhanced OTP Verification Step */}
                                    {currentStep === 'otp' && (
                                        <div className='text-left animate-fadeIn'>
                                            <div className="text-center mb-8">
                                                <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg animate-pulse">
                                                    <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                        <path d="M2.003 5.884l7.997 4.998 7.997-4.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                                        <path d="M18 8.118l-8 5-8-5V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                                    </svg>
                                                </div>
                                                <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Email Verification</h3>
                                                <p className="text-gray-600 mb-2 text-lg">
                                                    We've sent a verification code to
                                                </p>
                                                <p className="font-bold text-blue-600 text-lg mb-6">{email}</p>
                                                <p className="text-gray-500">Please enter the 6-digit code below</p>
                                            </div>
                                            
                                            <div className="max-w-md mx-auto">
                                                <div className="mb-6">
                                                    <label className='block mb-4 font-bold text-center text-gray-700'>Verification Code</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            value={otpCode}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                                                                setOtpCode(value);
                                                                setOtpErrors({});
                                                            }}
                                                            placeholder="000000"
                                                            className='w-full p-4 border-2 border-gray-200 rounded-2xl text-center text-2xl tracking-[0.5em] font-bold focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 bg-gray-50 focus:bg-white'
                                                            maxLength={6}
                                                        />
                                                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center">
                                                            <svg className={`w-6 h-6 transition-colors ${otpCode.length === 6 ? 'text-green-500' : 'text-gray-400'}`} fill="currentColor" viewBox="0 0 20 20">
                                                                <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-0.257-.257A6 6 0 1118 8zm-6-4a2 2 0 11-4 0 2 2 0 014 0zm-2 4a2 2 0 100 4 2 2 0 000-4z" clipRule="evenodd" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    {otpErrors.otp && <p className="text-red-500 text-sm mt-3 text-center animate-slideDown flex items-center justify-center"><svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>{otpErrors.otp}</p>}
                                                </div>
                                                
                                                <div className="text-center mb-6">
                                                    {showResendOtp ? (
                                                        <button 
                                                            type="button"
                                                            onClick={handleResendOtp}
                                                            disabled={isOtpLoading}
                                                            className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-700 rounded-xl hover:bg-blue-200 transition-all duration-200 font-semibold transform hover:scale-105"
                                                        >
                                                            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                                                            </svg>
                                                            {isOtpLoading ? t('form_sending') : t('form_resend_code')}
                                                        </button>
                                                    ) : (
                                                        <div className="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-600 rounded-xl">
                                                            <svg className="w-4 h-4 mr-2 animate-spin" fill="currentColor" viewBox="0 0 20 20">
                                                                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                                                            </svg>
                                                            {t('form_resend_timer', { seconds: resendTimer })}
                                                        </div>
                                                    )}
                                                </div>
                                                
                                                <div className="w-full">
                                                    <button
                                                        type="button"
                                                        onClick={handleOtpVerification}
                                                        disabled={isOtpLoading || otpCode.length !== 6}
                                                        className={`w-full text-white py-4 text-lg font-bold rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-blue-300 ${
                                                            isOtpLoading || otpCode.length !== 6 
                                                                ? 'bg-gray-400 cursor-not-allowed opacity-60' 
                                                                : 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-lg hover:shadow-blue-300/50'
                                                        }`}
                                                    >
                                                        {isOtpLoading ? (
                                                            <div className="flex items-center justify-center">
                                                                <ClipLoader size={24} color={"#fff"} />
                                                                <span className="ml-3">
                                                                    {currentStep === 'otp' ? t('form_verifying') : t('form_registering_product')}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className="flex items-center justify-center">
                                                                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                                </svg>
                                                                {t('form_verify_continue')}
                                                            </div>
                                                        )}
                                                    </button>
                                                </div>
                                                {otpErrors.general && <p className="text-red-500 text-center mt-4">{otpErrors.general}</p>}
                                            </div>
                                        </div>
                                    )}

                                    {/* Product Registration Step */}
                                    {currentStep === 'register' && (
                                        <div className='text-left'>
                                            <h3 className="text-xl font-bold mb-4 text-center">{t('form_complete_registration')}</h3>
                                            <p className="text-gray-600 mb-6 text-center">
                                                {t('form_account_verified')}
                                            </p>
                                            
                                            <div className="max-w-md mx-auto text-center">
                                                <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded">
                                                    <div className="flex items-center justify-center mb-2">
                                                        <svg className="w-6 h-6 text-green-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                        </svg>
                                                        <span className="font-semibold text-green-800">{t('form_account_verified_status')}</span>
                                                    </div>
                                                    <p className="text-sm text-green-700">
                                                        {firstName} {lastName} • {email}
                                                    </p>
                                                </div>
                                                
                                                <button
                                                    type="button"
                                                    onClick={handleProductRegistration}
                                                    disabled={isLoading}
                                                    className={`w-full text-white py-3 text-lg font-medium rounded hover:bg-yellow-600 ${
                                                        isLoading ? 'bg-yellow-400 opacity-70 cursor-not-allowed' : 'bg-[#F7941D]'
                                                    }`}
                                                >
                                                    {isLoading ? <ClipLoader size={20} color={"#fff"} /> : t('form_register_product')}
                                                </button>
                                                
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setCurrentStep('form');
                                                        setOtpCode('');
                                                        setOtpErrors({});
                                                    }}
                                                    className="w-full mt-3 py-3 text-lg font-medium rounded border border-gray-300 hover:bg-gray-50"
                                                >
                                                    {t('form_edit_details')}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </>}
                        </div>)}
            </div>
            <Footer companyInfo={companyInfo} />
            {isModalOpen && <FilePreviewModal fileUrl={fileUrl} onClose={() => setIsModalOpen(false)} />}
        </div>
    );
}

export default ProductRegistrationForm;
